const usePayments = ({ payments, onChange }) => {
  const getTotalPayments = () =>
    payments.reduce((t, p) => t + (parseFloat(p.amount) || 0), 0);

  const addPayment = () => {
    onChange([
      ...payments,
      {
        type: '',
        vat: payments.length > 0 ? payments[0].vat : null,
        booking_date: null,
        isPaid: false,
        cashed_date: null,
        amount: '',
      },
    ]);
  };

  const deletePayment = (index) =>
    onChange(payments.filter((_, i) => i !== index));

  const reorderPayments = (from, to) => {
    const arr = [...payments];
    const [item] = arr.splice(from, 1);
    arr.splice(to, 0, item);
    onChange(arr);
  };

  const _update = (index, fn) => {
    const arr = [...payments];
    arr[index] = fn(arr[index]);
    onChange(arr);
  };

  const handleTypeChange = (i, v) => _update(i, (p) => ({ ...p, type: v }));
  const handleDateChange = (i, d) =>
    _update(i, (p) => ({ ...p, booking_date: d }));

  const handleAmountChange = (pi, raw) => {
    const v = raw.replace(/[^0-9]/g, '');
    _update(pi, (p) => ({ ...p, amount: v }));
  };

  const handleStatusChange = (i, isPaid) =>
    _update(i, (p) => ({
      ...p,
      isPaid,
      cashed_date: isPaid ? p.booking_date : null,
      cashed: isPaid ? parseInt(p.amount) || null : null,
    }));

  const handleVATChange = (value) =>
    onChange(
      // `locked` is only ever set by EditPaymentModal for already-paid/invoiced
      // payments; absent everywhere else (e.g. the contract creation wizard).
      payments.map((p) => (p.locked ? p : { ...p, vat: value === '' ? null : parseInt(value) }))
    );

  const handleVATChangeForIndex = (index, value) =>
    _update(index, (p) =>
      p.locked ? p : { ...p, vat: value === '' ? null : parseInt(value) }
    );

  const getPaymentTotal = (p) => parseInt(p.amount) || 0;

  return {
    getTotalPayments,
    addPayment,
    deletePayment,
    reorderPayments,
    handleTypeChange,
    handleDateChange,
    handleAmountChange,
    handleStatusChange,
    handleVATChange,
    handleVATChangeForIndex,
    getPaymentTotal,
  };
};

export default usePayments;
